// Fixed English (en-GB style) names so output never depends on the engine's ICU data.
const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const pad = n => String(n).padStart(2, '0');

/** "Mon 2 Nov" (local) */
export const formatShortDate = value => {
    const d = new Date(value);
    return `${DAYS[d.getDay()]} ${d.getDate()} ${MONTHS[d.getMonth()]}`;
};

/** "2 Nov" (local) */
export const formatDayMonth = value => {
    const d = new Date(value);
    return `${d.getDate()} ${MONTHS[d.getMonth()]}`;
};

/** "06:30" 24-hour (local) */
export const formatTime = value => {
    const d = new Date(value);
    return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/** "5,200" */
export const formatThousands = n => Number(n).toLocaleString('en-US');
